import { useEffect } from 'react'
import {
  BrowserRouter,
  Routes,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom'
import * as Sentry from '@sentry/react'
import './lib/sentry'
import { syncSentryUser } from './lib/sentry'
import { supabase } from './lib/supabase'
import RequireAuth from './components/RequireAuth'
import RequireAdmin from './components/RequireAdmin'
import NavBar from './components/NavBar'
import Login from './pages/Login'
import Logout from './pages/Logout'
import ResetPassword from './pages/ResetPassword'
import Home from './pages/Home'
import Manage from './pages/Manage'
import Admin from './pages/Admin'
import Gallery from './pages/Gallery'

const SentryRoutes = Sentry.withSentryReactRouterV7Routing(Routes)

const NAV_ROUTES = ['/manage', '/admin']

function Layout() {
  const location = useLocation()
  const navigate = useNavigate()
  const showNav = NAV_ROUTES.includes(location.pathname)

  useEffect(() => {
    syncSentryUser()
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event) => {
      if (event === 'PASSWORD_RECOVERY') navigate('/reset-password', { replace: true })
      if (event === 'SIGNED_IN' || event === 'SIGNED_OUT') syncSentryUser()
    })
    return () => subscription.unsubscribe()
  }, [navigate])

  return (
    <>
      {showNav && <NavBar />}
      <SentryRoutes>
        <Route path="/login" element={<Login />} />
        <Route path="/logout" element={<Logout />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/" element={<Home />} />
        <Route path="/manage" element={<RequireAuth><Manage /></RequireAuth>} />
        <Route path="/admin" element={<RequireAdmin><Admin /></RequireAdmin>} />
        <Route path="/:shortCode" element={<Gallery />} />
      </SentryRoutes>
    </>
  )
}

function App() {
  return (
    <Sentry.ErrorBoundary fallback={<p className="p-4 text-red-600">Noe gikk galt.</p>}>
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  )
}

export default App
